module.exports = __webpack_public_path__ + "img/proactive-icon.df96491e.svg";